var module = angular.module('octopusApp.accounts', []);

module.config(function($stateProvider) {
    $stateProvider.state('app.accounts', {
        url: '/accounts',
        template: '<ui-view></ui-view>',
        layout: {
            tab: 'environments'
        },
        defaultSubRoute: "app.accounts.list"
    });

    $stateProvider.state("app.accounts.list", {
        url: '',
        templateUrl: 'areas/accounts/views/index.html',
        controller: 'AccountsIndexController',
        layout: {
            title: 'Accounts',
        }
    });

    $stateProvider.state("app.accounts.new", {
        url: '/new',
        templateUrl: 'areas/accounts/views/edit.html',
        controller: 'AccountEditController',
        controllerAs: 'vm',
        layout: {
            title: 'New Account'
        }
    });

    $stateProvider.state("app.accounts.edit", {
        url: '/:accountId',
        templateUrl: 'areas/accounts/views/edit.html',
        controller: 'AccountEditController',
        controllerAs: 'vm',
        layout: {
            title: 'Edit Account'
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/accounts_module.js
// module id = 3102405042776745
// module chunks = 1